/**
 * 增强 sa, 修正 sa 的bug
 */
import track from './track';
import { check as checkEvent } from './events';
import { check as checkObjType } from './obj-types';
import * as cookie from '../../cookie';
import * as utilObject from '../../object';
import { getReferrer } from '../../fix-referrer';
import { getPageNameFromUrl } from './pages';


// 暴露接口
export { track };

/**
 * 扩展功能
 */
// 将 url 转为 pageName
track.use((params) => {
  const objType = params.properties.obj_type || window.location.href;
  if (objType.indexOf('http') === 0) {
    params.properties.obj_type = getPageNameFromUrl(objType);
  }
});
// 检查 eventName 是否合法
track.use((params) => {
  checkEvent(params.eventName);
});
// 检查 obj_type 是否合法
track.use((params) => {
  checkObjType(params.properties.obj_type);
});
// 关联用户账号
track.use((params) => {
  params.properties = {
    sa_login_id: cookie.get('cdb_uid') || 0,
    user_action_id: cookie.get('user_action_id') || 0,
    ...params.properties
  };
});
// 功能性的优化。具体原因问 @关江辉
track.use((params) => {
  if (params.eventName === 'page_view') {
    window.$sa_readtime = {
      obj_type: params.properties.obj_type
    };
  }
});
// 自定义 page_source_type，并修正APP内的`referrer_url`
track.use((params) => {
  const referrer = getReferrer();

  params.properties = {
    // 因为大数据JS SDK或租租车APP的bug
    referrer_url: referrer,
    // 因为大数据不想根据 url 写正则筛选数据
    page_source_type: getPageNameFromUrl(referrer),
    ...params.properties
  };
});


// 自动上报
setTimeout(() => {
  track('show', {
    obj_type: utilObject.get(window, 'location.href'),
    obj_id: 'auto'
  });
});
